module.exports = __webpack_public_path__ + "img/text-mark3.0186d36a.png";